import Layout from '@/layout';

export default [
  {
    path: '/charts',
    name: 'Charts',
    redirect: '/charts/map',
    component: Layout,
    meta: {
      title: '数据中心',
      icon: 'icon-charts',
    },
    children: [
      {
        path: 'map',
        name: 'ChartsMap',
        component: () => import('@/views/charts/Map'),
        meta: {
          title: '数据中心',
          showSideBar: true,
          // desc: '导出数据',
        },
        hidden: true,
      },
      // {
      //   path: 'resource',
      //   name: 'ChartsResource',
      //   component: () => import('@/views/charts/Resource'),
      //   meta: {
      //     title: '资源数据',
      //   },
      // },
      {
        path: 'map-detail',
        name: 'ChartsMapDetail',
        component: () => import('@/views/charts/MapDetail'),
        meta: {
          title: '地图详情',
          activePath: 'map',
        },
        hidden: true,
      },
      {
        path: 'map-list',
        name: 'ChartsMapList',
        component: () => import('@/views/charts/MapList'),
        meta: {
          title: '地图列表',
          activePath: 'map',
        },
        hidden: true,
      },
    ],
  },
];
